import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Esto cura el tinnitus?',
    a: 'No. Este protocolo no promete curar, diagnosticar ni tratar una condición médica. Está diseñado como una herramienta de apoyo para ayudar a calmar la atención, reducir la activación nocturna y mejorar la relación mental con el zumbido.'
  }, {
    q: '¿Cuánto tiempo tarda?',
    a: 'La rutina principal dura aproximadamente 3 minutos. Algunas personas la repiten una segunda vez si tienen una noche difícil.'
  }, {
    q: '¿Necesito audífonos?',
    a: 'No necesariamente. Puedes usarlo desde tu celular en volumen bajo y cómodo.'
  }, {
    q: '¿Funciona si llevo años con zumbido?',
    a: 'Puede ayudarte si tu principal problema es que el zumbido se vuelve más molesto por la noche, especialmente cuando aparece ansiedad, frustración o vigilancia constante. No reemplaza atención médica.'
  }, {
    q: '¿Puedo usarlo con otros métodos?',
    a: 'Sí. Puedes combinarlo con hábitos de sueño, recomendaciones médicas o sonidos ambientales si ya los usas.'
  }, {
    q: '¿Cuándo recibo el acceso?',
    a: 'Inmediatamente después del pago.'
  }];
  return <section className="py-16 md:py-24 px-5 md:px-8" data-id="element-155">
      <div className="max-w-3xl mx-auto" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-157">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-158">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-159">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} index={i} data-id="element-160" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer,
  index
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.4,
    delay: index * 0.1
  }} className="bg-[#0B1224] border border-[#15203B] rounded-xl overflow-hidden" data-id="element-161">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-162">
        <span className="font-bold text-white text-lg pr-4" data-id="element-163">{question}</span>
        <span className={`text-[#F6C65B] text-2xl transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} data-id="element-164">
          +
        </span>
      </button>
      <AnimatePresence data-id="element-165">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-166">
            <div className="px-6 pb-5 text-gray-300 leading-relaxed border-t border-[#15203B] pt-4" data-id="element-167">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}